/**
 * Authentication Service
 * Handles all authentication-related API calls
 */

import axiosInstance from '../axios.config';
import API_ENDPOINTS from '../endpoints';

export const authService = {
  // Login
  login: async (credentials) => {
    const response = await axiosInstance.post(API_ENDPOINTS.AUTH.LOGIN, credentials);
    
    // Response is already transformed by axios interceptor (returns response.data)
    // Backend returns: { status: 'success', data: { user, tokens: { access_token, refresh_token } }, message }
    if (response && response.status === 'success' && response.data) {
      // Extract tokens from response.data.tokens
      // Backend structure: { user: {...}, tokens: { access_token, refresh_token, token_type, expires_in } }
      const tokens = response.data.tokens || {};
      const token = tokens.access_token || tokens.token || tokens.accessToken;
      const refreshToken = tokens.refresh_token || tokens.refreshToken;
      const user = response.data.user;
      
      // Store tokens
      if (token) {
        localStorage.setItem('accessToken', token);
      }
      if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken);
      }
      // Store user data for AuthContext
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
      }
    }
    
    return response;
  },

  // Register
  register: async (userData) => {
    return await axiosInstance.post(API_ENDPOINTS.AUTH.REGISTER, userData);
  },

  // Logout
  logout: async () => {
    try {
      await axiosInstance.post(API_ENDPOINTS.AUTH.LOGOUT);
    } finally {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
    }
  },

  // Get current user
  getCurrentUser: async () => {
    return await axiosInstance.get(API_ENDPOINTS.AUTH.ME);
  },

  // Forgot password
  forgotPassword: async (email) => {
    return await axiosInstance.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
  },

  // Reset password
  resetPassword: async (token, newPassword) => {
    return await axiosInstance.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, {
      token,
      newPassword,
    });
  },

  // Verify email
  verifyEmail: async (token) => {
    return await axiosInstance.post(API_ENDPOINTS.AUTH.VERIFY_EMAIL, { token });
  },
};

export default authService;

